import fileMD5 from './fileMD5Utils'
// import { uploadPartInit, uploadPart, uploadPartMerge } from "@/api/index";
import axios from 'axios'
import { Message } from 'element-ui';
const CancelToken = axios.CancelToken;

const sliceFile = file => {
    const list = []
    var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
        chunkSize = 1048576,                             // Read in chunks of 1MB
        chunks = Math.ceil(file.size / chunkSize),
        currentChunk = 0;

    while (currentChunk < chunks) {
        var start = currentChunk * chunkSize,
        end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
        list.push(blobSlice.call(file, start, end))
        currentChunk++
    }
    return list
}


class PartUpload {
    constructor({
        onUploadSucceed,
        onUploadProgress
    }) {
        this.onUploadSucceed = onUploadSucceed
        this.onUploadProgress = onUploadProgress


        this.file = null
        this.cancel = false
    }

    addFile(file) {
        this.file = file
    }

    async startUpload() {
        const md5 = await fileMD5(this.file)
        let response = await axios.get(`${process.env.VUE_APP_API_DOMAIN}/upload/part/init`, { params: { md5, fileName: this.file.name } })
        const res = response.data
        // const res = await uploadPartInit({ fileMd5: md5, fileName: this.file.name })
        if (res.code == 0) {
            let currentSize = 0
            if (res.data.state == "COMPLETE") {
                this.onUploadSucceed(res.data)
            } else {
                const parts = sliceFile(this.file)
                let that = this;
                for (let i = 0; i < parts.length; i++) {
                    const formData = new FormData()
                    formData.append('fileId', res.data.fileId)
                    formData.append("index", i)
                    formData.append('file', parts[i])
                    await axios.post(`${process.env.VUE_APP_API_DOMAIN}/upload/part/upload`, formData, {
                        cancelToken: new CancelToken(function executor(c) {
                            // An executor function receives a cancel function as a parameter
                            that.cancelUpload = c;
                        })
                    }).catch(function(thrown) {
                        if (axios.isCancel(thrown)) {
                            that.cancel = true;
                            console.log('Request canceled', thrown);
                        } else {
                            // handle error
                        }
                    });
                    if (this.cancel) break;
                    // const partRes = await uploadPart(formData)
                    currentSize += parts[i].size
                    this.onUploadProgress(currentSize / this.file.size)
                }
                if (this.cancel) return;
                response = await axios.get(`${process.env.VUE_APP_API_DOMAIN}/upload/part/merger`, { params: { fileId:  res.data.fileId} })
                const mergeRes = response.data
                // const mergeRes = await uploadPartMerge(res.data.fileId)
                if (mergeRes.code === 0) {
                    this.onUploadSucceed(mergeRes.data)
                } else {
                    Message({
                        message: mergeRes.msg,
                        type: 'error'
                    }, true)
                }
            }
        } else {
            Message({
                message: res.msg,
                type: 'error'
            }, true)
        }
    }

    cancelUpload
}

export default ({ onUploadSucceed, onUploadProgress }) => {
    return new PartUpload({
        onUploadSucceed,
        onUploadProgress
    })
}